import { render, staticRenderFns } from "./auto_view_v2.vue?vue&type=template&id=f4c5172c&scoped=true"
import script from "./auto_view_v2.vue?vue&type=script&lang=js"
export * from "./auto_view_v2.vue?vue&type=script&lang=js"
import style0 from "./auto_view_v2.vue?vue&type=style&index=0&id=f4c5172c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c5172c",
  null
  
)

export default component.exports